import React from "react";
import NutrientsChart from "./NutrientsChart";
import { getDisplayDate } from "../../../../utils/date-helpers";

const NutritionPlanChart = ({ planStats }) => {
  const { startDate, endDate, restDay, notes } = planStats;

  return (
    <div className="nutrition-plan-summary">
      <p className="nutrition-plan-summary-title s1">Plan</p>

      <p className="p4">
        {getDisplayDate(startDate, true)} to {getDisplayDate(endDate, true)}
      </p>

      {!!restDay ? (
        <div className="rest-day-charts">
          <div className="nutrition-day-stats">
            <h5>Training Day</h5>
            <NutrientsChart
              key={"nutrition-plan-summary-chart"}
              dayStats={planStats}
              height={250}
              width={250}
              providedId={"nutrition-plan-summary-chart-training-day-xd"}
            />
          </div>

          <div className="nutrition-day-stats">
            <h5>Rest Day</h5>
            <NutrientsChart
              key={"nutrition-plan-summary-chart"}
              dayStats={{ nutrients: { ...restDay } }}
              height={250}
              width={250}
              providedId={"nutrition-plan-summary-chart-rest-day-xd"}
            />
          </div>
        </div>
      ) : (
        <NutrientsChart
          key={"nutrition-plan-summary-chart"}
          dayStats={planStats}
          height={250}
          providedId={"nutrition-plan-chart-xd"}
        />
      )}

      {!!notes && (
        <>
          <p className="clipped mt-4">Notes</p>
          <div className="nutrition-plan-notes">
            <p className="p4">{notes}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default NutritionPlanChart;
